import { UserSettings } from "@/database/userDatabaseService";
import { EraserShortCuts, PageItemPosition } from "@/types";

// src/appSetting.ts
export interface AppSetting {
  UseSimulation: boolean;
  UseGeoGebra: boolean;
  InitialLanguage: string;
  DefaultUserSettings: UserSettings;
}

export const defaultSetting: AppSetting = {
  UseSimulation: true,
  UseGeoGebra: true,
  InitialLanguage: "tr",
  DefaultUserSettings: {
    userId: "1000-0000-0000-0001",
    showContentInfo: true,
    pageItemPosition: PageItemPosition.left,
    pageItemIsFull: true,
    saveDrawings: true,
    continueLastPage: true,
    showNextAreaOnPageNavigation: false,
    isToolsAutoMoving: true,
    hideIcons: false,
    toolBoxSize: 1,
    selectedTools: ["pan", "pencil", "eraser"],
    eraserShortCut: EraserShortCuts.Closed,
    longPressTime: 500,
    colors: ["#000000", "#FF0000", "#0000FF", "#00FF00", "#FFCC00", "#FFC0CB"],
    thickness: [3, 5, 7, 8],
  },
};

export async function loadAppSettings(): Promise<AppSetting> {
  try {
    const response = await fetch(process.env.PUBLIC_URL + "/setting.json");
    if (!response.ok) {
      console.warn("setting.json bulunamadı, default ayarlar kullanılacak.");
      return defaultSetting;
    }
    const json = await response.json();
    return { ...defaultSetting, DefaultUserSettings: {...defaultSetting.DefaultUserSettings, ...json }};
  } catch (error) {
    console.error("Config yüklenirken hata:", error);
    return defaultSetting;
  }
}
